import { AMOUNT_TYPE, ITEM_TYPE } from '@/utils/enum';

const calculateMixin = {
  methods: {
    calculateTotalAmountOrderItems(item) {
      const sellingPrice = item.sellingPriceMask || 0;
      const quantity = item.quantity || 0;
      const discountAmount = item.discountAmount || 0;
      let totalAmountItem = 0;
      const discountType = item.discountType || AMOUNT_TYPE.MONEY;

      if (quantity > 0) {
        let discountPerUnit = 0;

        if (discountType === AMOUNT_TYPE.PERCENT) {
          discountPerUnit = sellingPrice * (discountAmount / 100);
        } else {
          discountPerUnit = discountAmount;
        }

        totalAmountItem =
          Number(sellingPrice) * Number(quantity) -
          discountPerUnit * Number(quantity);
      }

      return totalAmountItem;
    },
    calculateDiscountAmount(discount, type, money, quantity = 1) {
      let amount = 0;
      const PERCENT_100 = 100;
      // percent default discount by 1 product or item
      if (type === AMOUNT_TYPE.PERCENT) {
        amount = money * (discount / PERCENT_100);
      } else {
        amount = discount / quantity;
      }
      return amount;
    },
    applyDiscounts(price, itemDiscount, allocatedDiscount) {
      return (
        Number(price) -
        Number(itemDiscount || 0) -
        Number(allocatedDiscount || 0)
      );
    },
    calculateAmountBillItems(billItems) {
      if (!Array.isArray(billItems) || billItems.length === 0) {
        return 0;
      }
      const sellingBillItems = billItems.filter(
        (billItem) => billItem.itemType !== ITEM_TYPE.GIFT,
      );

      return sellingBillItems.reduce((totalAmount, billItem) => {
        const {
          sellingPrice = 0,
          sellingPriceMask = 0,
          quantity = 0,
          discountAmount = 0,
          discountType,
        } = billItem;

        const productPrice = sellingPriceMask || sellingPrice;

        const actualDiscountAmount = this.calculateDiscountAmount(
          discountAmount,
          discountType,
          productPrice,
        );

        const itemAmount = (productPrice - actualDiscountAmount) * quantity;

        return totalAmount + itemAmount;
      }, 0);
    },
    calculateProportionalDiscount(
      item,
      totalAfterIndividualDiscounts,
      totalOrderDiscount,
    ) {
      if (totalAfterIndividualDiscounts === 0) {
        return 0;
      }

      const itemPriceAfterIndividualDiscount =
        this.calculateTotalAmountOrderItems(item);
      const proportionalDiscount =
        (itemPriceAfterIndividualDiscount / totalAfterIndividualDiscounts) *
        totalOrderDiscount;

      return proportionalDiscount;
    },
    calculateFinalPriceAfterAllDiscounts(
      item,
      totalAfterIndividualDiscounts,
      totalOrderDiscount,
    ) {
      const itemPriceAfterIndividualDiscount =
        this.calculateTotalAmountOrderItems(item);
      const proportionalDiscount = this.calculateProportionalDiscount(
        item,
        totalAfterIndividualDiscounts,
        totalOrderDiscount,
      );
      const finalPrice =
        itemPriceAfterIndividualDiscount - proportionalDiscount;

      return Math.max(Math.round(finalPrice * 100) / 100, 0);
    },
    calculateTotalDiscountItems(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return 0;
      }
      const sellingBillItems = items.filter(
        (item) => item.itemType !== ITEM_TYPE.GIFT,
      );

      return sellingBillItems.reduce((totalDiscountAmount, item) => {
        const {
          sellingPrice = 0,
          sellingPriceMask = 0,
          quantity = 0,
          discountAmount = 0,
          discountType,
        } = item;

        const productPrice = sellingPriceMask || sellingPrice;

        const actualDiscountAmount = this.calculateDiscountAmount(
          discountAmount,
          discountType,
          productPrice,
        );

        return totalDiscountAmount + actualDiscountAmount * quantity;
      }, 0);
    },
  },
};
export default calculateMixin;
